import type { ReactNode } from 'react'

interface KpiCardProps {
  label: string
  value: string | number
  sub?: string
  subColor?: 'green' | 'red' | 'gray'
  icon?: ReactNode
  loading?: boolean
  color?: string
}

const subColorMap = { green: '#059669', red: '#dc2626', gray: '#9ca3af' }

export default function KpiCard({ label, value, sub, subColor = 'gray', icon, loading, color }: KpiCardProps) {
  if (loading) {
    return (
      <div style={{
        background: '#fff',
        borderRadius: '12px',
        padding: '20px 24px',
        border: '1px solid #f3f4f6',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}>
        <div style={{ height: 13, width: '60%', borderRadius: 6, background: '#f3f4f6', animation: 'pulse 1.5s ease-in-out infinite' }} />
        <div style={{ height: 28, width: '40%', borderRadius: 6, background: '#f3f4f6', animation: 'pulse 1.5s ease-in-out infinite' }} />
        <div style={{ height: 12, width: '70%', borderRadius: 6, background: '#f3f4f6', animation: 'pulse 1.5s ease-in-out infinite' }} />
      </div>
    )
  }

  return (
    <div style={{
      background: '#fff',
      borderRadius: '12px',
      padding: '20px 24px',
      border: '1px solid #f3f4f6',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      overflow: 'hidden',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontSize: '13px', color: '#6b7280', fontWeight: 400 }}>{label}</span>
        {icon && <span style={{ color: color ?? '#1D9E75' }}>{icon}</span>}
      </div>
      <div style={{ fontSize: '28px', fontWeight: 700, fontFamily: 'Syne, sans-serif', lineHeight: 1, color: color ?? '#0D1117' }}>
        {value}
      </div>
      {sub && (
        <div style={{ fontSize: '12px', color: subColorMap[subColor] }}>{sub}</div>
      )}
    </div>
  )
}
